module.exports = __webpack_public_path__ + "img/grey.51730f7.svg";